import React from 'react';
import IconContainer from '../../../common/IconContainer/IconContainer';
import styles from './Notification.module.css';

function NotificationFtux() {
  return (
    <div className={styles.notificationFtuxContainer}>
      <IconContainer icon="🔔" />
      <div>
        <div className={styles.notificationFtuxTitle}>No Notification Yet</div>
        <div className={styles.notificationFtuxSubTitle}>Your notification will show up here. Stay tuned!</div>
      </div>
    </div>
  );
}

export default NotificationFtux;
